import React, { Component } from "react";
import { connect } from "react-redux";

const mapLegend = {
  position: "absolute",
  width: "20%",
  height: "5%",
  top: "0%",
  right: "10%",
  zIndex: "6",
  padding: "5px",
  border: "0px solid #999"
  //backgroundColor: "rgba(255,255,255,0.8)"
};

class Mousepositioninfo extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loclatMouse: null
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    var lon = nextProps.lonlatMouse[0].toFixed(2) ;
    var lat = nextProps.lonlatMouse[1].toFixed(2) ;

    this.setState({ loclatMouse: `lon: ${lon} | lat ${lat}` });
  }

  render() {
    return <div style={mapLegend}>{this.state.loclatMouse}</div>;
  }

}



function mapStateToProps(state) {
  return {
    blocking: state.loader,
    lonlatMouse: state.lonlatMouse
  };
}

export default connect(mapStateToProps)(Mousepositioninfo);
